import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LinkTarget } from '@app/shared/models/linkTarget';

const apiLinkVersion = '10-2019';

@Injectable({
  providedIn: 'root'
})
export class LinkService {

  constructor(private http: HttpClient) { }

  headers = new HttpHeaders().set('Authorization', 'true');

  getTarget(source: string): Observable<{ target: LinkTarget }> {
    return this.http.get<{ target: LinkTarget }>('service:link' + '/target/' + source + '?version=' + apiLinkVersion, { headers: this.headers });
  }
}
